import AuthDesktopContainer from './AuthDesktopContainer';
export default AuthDesktopContainer;
